import { durationPresetDays, durationPresetKeys, loyaltyTypesKeys } from '../constants';

function buildConfig(form) {
  if (form.type === loyaltyTypesKeys.cashback) {
    return {
      Modo: form.cashbackModo,
      ValorFixo:
        form.cashbackModo !== 'percentual' ? Number(form.cashbackFixedValue) || 0 : undefined,
      Percentual:
        form.cashbackModo === 'percentual' ? Number(form.cashbackPercentage) || 0 : undefined,
      ValorMetaAcumulo:
        form.cashbackModo === 'meta_valor' ? Number(form.cashbackGoalValue) || 0 : undefined,
    };
  }

  if (form.type === loyaltyTypesKeys.pedidos) {
    return { QuantidadeMeta: Number(form.goalQuantity) || 0 };
  }

  if (form.type === loyaltyTypesKeys.valor_acumulado) {
    return { ValorMeta: Number(form.goalValue) || 0 };
  }

  return {};
}

function buildReward(form) {
  if (form.type === loyaltyTypesKeys.cashback) {
    return { Tipo: 'cashback' };
  }

  return {
    Tipo: form.rewardType,
    Valor:
      form.rewardType === 'desconto_fixo' || form.rewardType === 'cashback'
        ? Number(form.rewardValue) || 0
        : undefined,
    Porcentagem:
      form.rewardType === 'desconto_percentual' ? Number(form.rewardPercentage) || 0 : undefined,
  };
}

function buildDuracaoDias(form) {
  if (form.durationPreset === durationPresetKeys.personalizado) {
    return form.durationCustomDays ? Number(form.durationCustomDays) : undefined;
  }

  return durationPresetDays[form.durationPreset] ?? null;
}

export function parseFormToProgram(form, companyId) {
  return {
    Id: form.id || undefined,
    IdEmpresa: companyId,
    Tipo: form.type,
    Nome: form.name,
    Descricao: form.description,
    Config: buildConfig(form),
    Recompensa: buildReward(form),
    ValidadeBeneficioDias: form.validityDays ? Number(form.validityDays) : undefined,
    DuracaoDias: buildDuracaoDias(form),
    Status: form.status,
  };
}
